import { t } from 'i18next';

export const getProductConfig = (clientId, type = 'telegram') => {
  const channels = {
    lynq: {
      name: t('lynq'),
      url: '+QOGvu8AHMAw3MzMx',
    },
    lynqNOA: {
      name: t('lynq'),
      url: '+9jMSh6osEJg0NDUx',
    },
    tradingAndServicios: {
      name: t('spanishLiveTradingAndEducationalSessions')?.toUpperCase(),
      url: '+V2WF0o6QOTUyZDQx',
    },
    fuzion: {
      name: t('fuzion'),
      url: '+karPRcORr7Q1NjNh',
    },
    axis: {
      name: t('axis'),
      url: '+DkRHiBngyD80YzMx',
    },
    anon: {
      name: t('Anon'),
      url: '+fG4h6hcFRNE3NDEx',
    },
    harmoney: {
      name: t('harmoney'),
      url: '+U2GVeVDiEcs3YzAx',
    },
    profitLock: {
      name: t('profitLock'),
      url: '+roPxmCNYCnNmMDMx',
    },
    us30: {
      name: 'US30',
      url: '+n9Q4WR6e82Y4MzEx',
    },
    power: {
      name: 'Power',
      url: '+JWcZIyl7isszMDlh',
    },
    // NITRO USA
    nitro: {
      name: 'Nitro',
      url: '+F_H-ZiKAC843NWUx',
    },
    // NITRO ITALY
    azionario: {
      name: 'Azionario',
      url: '+Y-almwV_nho2YWNh',
    },
    nitrostocks: {
      name: 'Nitro Certificati e Derivati',
      url: '+SOeNjjCsPUpiNTkx',
    },
    pulse: {
      name: 'Pulse',
      url: '+UDqY9xLJYStjNGRh',
    },
    guiliano: {
      name: 'Guiliano',
      url: '+mSmoj5OC5Xw1Zjhh',
    },
    loop: {
      name: 'Loop',
      url: '+NuCMfiItB-ljMjJh',
    },
    // SURF ITALY
    // Italy version of the surf product
    macroeconomia: {
      name: 'Macroeconomia',
      url: '+IJFdi4MEJhZjNDQx',
    },
    // SURF USA
    surf: {
      name: 'Surf',
      url: '+xTEpS3BWOGk5Njhh',
    },
    goldRush: {
      name: 'Gold Rush',
      url: '+4I7xm2uYaJQ5ZmMx',
    },
  };

  const configs = {
    default: {
      telegram: [
        //channels.anon,
        channels.axis,
        channels.fuzion,
        channels.harmoney,
        channels.profitLock,
        //channels.power,
        channels.tradingAndServicios,
        channels.us30,
        channels.lynqNOA,
      ],
      businessHub: ['Affiliate Marketing Kit', 'Affiliate Services', 'Business Hub'],
      forexHub: [
        'Trade Ideas',
        'Solexx',
        'Strm',
        'Hummingbird',
        'Trading Journal',
        'Maitryx',
        'Gold Rush',
      ],
      maitryxHub: ['Maitryx'],
      academyHub: ['Academy'],
      lumenHub: ['Lumen'],
      marketingKitHub: ['Affiliate Marketing Kit'],
    },
    2: {
      tradingIdeas: [
        channels.axis,
        channels.fuzion,
        channels.harmoney,
        channels.profitLock,
        channels.tradingAndServicios,
        channels.us30,
        channels.lynqNOA,
      ],
      forexHub: [
        'Trade Ideas',
        'Solexx',
        'Strm',
        'Hummingbird',
        'Trading Journal',
        'Maitryx',
        'Gold Rush',
      ],
      telegram: [
        {
          product: 'Starter Pack',
          links: [
            channels.harmoney,
            channels.us30,
            channels.profitLock,
            //channels.power,
          ],
          weight: 0,
        },
        {
          product: 'Software Pack',
          links: [
            //channels.anon,
            channels.axis,
            channels.harmoney,
            channels.lynqNOA,
            //channels.power,
            channels.profitLock,
            channels.tradingAndServicios,
            channels.us30,
          ],
          weight: 1,
        },
        {
          product: 'Software Pro Pack',
          links: [
            //channels.anon,
            channels.axis,
            channels.fuzion,
            channels.harmoney,
            channels.lynqNOA,
            //channels.power,
            channels.profitLock,
            channels.tradingAndServicios,
            channels.us30,
          ],
          weight: 2,
        },
        {
          product: 'Software Gold Pack',
          links: [
            //channels.anon,
            channels.axis,
            channels.fuzion,
            channels.harmoney,
            channels.lynqNOA,
            //channels.power,
            channels.profitLock,
            channels.tradingAndServicios,
            channels.us30,
          ],
          weight: 3,
        },
        {
          product: '12-Week Access Package ',
          links: [
            //channels.anon,
            channels.axis,
            channels.harmoney,
            channels.lynqNOA,
            //channels.power,
            channels.profitLock,
            channels.tradingAndServicios,
            channels.us30,
          ],
          weight: 3,
        },
        {
          product: '24-Week Access Package ',
          links: [
            //channels.anon,
            channels.axis,
            channels.harmoney,
            channels.lynqNOA,
            //channels.power,
            channels.profitLock,
            channels.tradingAndServicios,
            channels.us30,
          ],
          weight: 3,
        },
        {
          product: '48-Week Access Package ',
          links: [
            //channels.anon,
            channels.axis,
            channels.harmoney,
            channels.lynqNOA,
            //channels.power,
            channels.profitLock,
            channels.tradingAndServicios,
            channels.us30,
          ],
          weight: 3,
        },
        {
          product: 'Gold Rush',
          links: [channels.goldRush],
          weight: 3,
        },
      ],
      timezone: 'Pacific Time (PT)',
      sharedReports: {
        associate: {
          rank: [
            { reportId: 11129, name: 'EQV', abbr: 'EQV' },
            { reportId: 11131, name: 'PEA', abbr: 'PEA' },
            { reportId: 11133, name: 'PEARL', abbr: 'PerEnrlRL' },
            { reportId: 11134, name: 'PELL', abbr: 'PerEnrlLL' },
            { reportId: 11473, name: 'BRLV', abbr: 'BCVR' },
            { reportId: 11475, name: 'BLLV', abbr: 'BCVL' },
            { reportId: 11476, name: 'CVLL', abbr: 'BRVL' },
            { reportId: 11477, name: 'CVRL', abbr: 'BRVR' },
          ],
        },
      },
      reportsCenterIds: {
        totalAssociates: 11580,
        affiliates: 11581,
        customers: 11582,
        preEnroll: 11583,
        totalAffiliates: 11639,
        activeAffiliates: 11640,
        totalCustomers: 11641,
        expiredSubscriptions: 11642,
      },
    },
    3: {
      timezone: 'Central European Time (CET)',
      sharedReports: {
        associate: {
          rank: [
            { reportId: 189, name: 'EQV', abbr: 'EQV' },
            { reportId: 190, name: 'PEA', abbr: 'PEA' },
            { reportId: 191, name: 'PEARL', abbr: 'PerEnrlRL' },
            { reportId: 192, name: 'PELL', abbr: 'PerEnrlLL' },
            { reportId: 193, name: 'BRLV', abbr: 'BCVR' },
            { reportId: 194, name: 'BLLV', abbr: 'BCVL' },
            { reportId: 196, name: 'CVLL', abbr: 'BRVL' },
            { reportId: 195, name: 'CVRL', abbr: 'BRVR' },
          ],
        },
      },
      optInTelegram: 'https://t.me/+YO5ihHvgj1FhMmQx',
      liveSessions: [
        {
          name: 'Software Pack',
          shortCode: 'starter',
          weight: 0,
        },
        {
          name: 'Software Pro Pack',
          shortCode: 'pro',
          weight: 1,
        },
        {
          name: 'Software Gold Pack',
          shortCode: 'elite',
          weight: 2,
        },
        {
          name: 'Starter Pack',
          shortCode: 'starter',
          weight: 0,
        },
        {
          name: 'Pro Pack',
          shortCode: 'pro',
          weight: 1,
        },
        {
          name: 'Elite Pack',
          shortCode: 'elite',
          weight: 2,
        },
        {
          name: 'Emerging Pack',
          shortCode: 'emerging',
          weight: 0,
        },
      ],
      telegram: [
        {
          product: 'Access Pack',
          links: [
            //channels.anon,
            channels.profitLock,
            channels.tradingAndServicios,
            //channels.power,
            channels.harmoney,
          ],
          weight: 0,
        },
        {
          product: 'Software Pack',
          links: [
            channels.axis,
            channels.profitLock,
            channels.pulse,
            channels.loop,
            channels.macroeconomia,
          ],
          weight: 0,
        },
        {
          product: 'Software Pro Pack',
          links: [
            channels.us30,
            channels.lynq,
            channels.axis,
            //channels.anon,
            channels.profitLock,
            channels.harmoney,
            //channels.power,
            //channels.azionario,
            channels.pulse,
            //channels.guiliano,
            channels.loop,
            channels.macroeconomia,
          ],
          weight: 1,
        },
        {
          product: 'Software Gold Pack',
          links: [
            channels.us30,
            channels.lynq,
            channels.axis,
            //channels.anon,
            channels.profitLock,
            channels.harmoney,
            //channels.power,
            //channels.azionario,
            //channels.nitrostocks,
            channels.pulse,
            //channels.guiliano,
            channels.loop,
            channels.macroeconomia,
          ],
          weight: 2,
        },
        {
          product: 'Starter Pack',
          links: [
            channels.axis,
            channels.profitLock,
            channels.pulse,
            channels.loop,
            channels.macroeconomia,
            channels.harmoney,
          ],
          weight: 0,
        },
        {
          product: 'Pro Pack',
          links: [
            channels.us30,
            channels.lynq,
            channels.axis,
            //channels.anon,
            channels.profitLock,
            channels.harmoney,
            //channels.power,
            //channels.azionario,
            channels.pulse,
            //channels.guiliano,
            channels.loop,
            channels.macroeconomia,
          ],
          weight: 1,
        },
        {
          product: 'Elite Pack',
          links: [
            channels.us30,
            channels.lynq,
            channels.axis,
            //channels.anon,
            channels.profitLock,
            channels.harmoney,
            //channels.power,
            //channels.azionario,
            channels.nitrostocks,
            channels.pulse,
            //channels.guiliano,
            channels.loop,
            channels.macroeconomia,
          ],
          weight: 2,
        },
        {
          product: 'Emerging Pack',
          links: [channels.axis, channels.profitLock],
          weight: 0,
        },
        {
          product: 'Gold Rush',
          links: [channels.goldRush],
          weight: 3,
        },
      ],
      businessHub: ['Affiliate Marketing Kit', 'Affiliate Services', 'Business Hub'],
    },
  };
  return configs?.[clientId]?.[type] || configs['default']?.[type] || [];
};
